<template>
  <div
    class="c-rect-item__content"
    :class="{ 'active' : active }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'c-rect-item-content',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
  .c-rect-item {
    &__content {
      position: relative;
      height: 100%;
      &.active {
        &:before {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          background: rgba(255,255,255, .5) !important;
          z-index: 2;
          border-radius: 12px;
        }
      }
    }
  }
</style>